import { COLORS } from '../lib/theme'
import { Icon, type IconName } from './Icon'
import { PageHeader } from './atoms'

export interface AccountEmptyShellProps {
  title: string
  subtitle: string
  icon: IconName
  headline: string
  body: string
  primary?: { label: string; icon?: IconName }
  secondary?: { label: string; icon?: IconName }
  accent?: string
}

export function AccountEmptyShell({
  title,
  subtitle,
  icon,
  headline,
  body,
  primary,
  secondary,
  accent,
}: AccountEmptyShellProps) {
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle} />
      <div
        className="wh-card"
        style={{
          padding: '64px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderStyle: 'dashed',
          borderWidth: 1.5,
          borderColor: COLORS.surfaceContainerHighest,
          background:
            'radial-gradient(circle at 50% 0%, rgba(32,80,43,0.04) 0%, transparent 60%), #fff',
        }}
      >
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius: 999,
            background: accent ? `${accent}15` : '#e6eee8',
            color: accent || COLORS.primary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 24,
          }}
        >
          <Icon name={icon} size={44} />
        </div>
        <div
          style={{
            fontFamily: COLORS.fontDisplay,
            fontSize: 26,
            fontWeight: 500,
            marginBottom: 10,
            lineHeight: 1.2,
            maxWidth: 480,
          }}
        >
          {headline}
        </div>
        <div
          style={{
            fontSize: 14,
            color: COLORS.outline,
            maxWidth: 480,
            lineHeight: 1.6,
            marginBottom: 28,
          }}
        >
          {body}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          {primary && (
            <button className="wh-btn wh-btn-primary">
              {primary.icon && <Icon name={primary.icon} size={16} />}
              {primary.label}
            </button>
          )}
          {secondary && (
            <button className="wh-btn wh-btn-outline">
              {secondary.icon && <Icon name={secondary.icon} size={16} />}
              {secondary.label}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
